import { Button, Dropdown, Tooltip } from "antd";
import { CheckOutlined, FontSizeOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";

import { selectFontScale, setFontScale } from "@/app/uiSlice";

/**
 * Steps the root font-size, which everything sized in rem follows from —
 * BMR_Frontend's FontSizeToggle.jsx, with the scale rules living in
 * index.css and the choice persisted through uiSlice.
 */
const SCALES = [
  { label: "Small", value: "sm" },
  { label: "Medium", value: "md" },
  { label: "Large", value: "lg" },
  { label: "Extra Large", value: "xl" },
];

export default function FontSizeToggle() {
  const dispatch = useDispatch();
  const fontScale = useSelector(selectFontScale);

  const items = SCALES.map(({ label, value }) => ({
    key: value,
    label: (
      <span className="inline-flex min-w-[110px] items-center gap-2">
        <CheckOutlined
          style={{
            visibility: value === fontScale ? "visible" : "hidden",
            fontSize: 12,
          }}
        />
        {label}
      </span>
    ),
  }));

  return (
    <Dropdown
      trigger={["click"]}
      placement="bottomRight"
      menu={{
        items,
        selectable: true,
        selectedKeys: [fontScale],
        onClick: ({ key }) => dispatch(setFontScale(key)),
      }}
    >
      <Tooltip title="Font size" placement="bottom">
        <Button
          type="text"
          shape="circle"
          className="header-icon-btn"
          icon={<FontSizeOutlined />}
          aria-label="Font size"
        />
      </Tooltip>
    </Dropdown>
  );
}
